export default __webpack_public_path__ + "static/media/american_card.54ab1d1d.png";